import React from "react";
import { Bet } from "@/api/betting";
import { Loader2 } from "lucide-react";
import BetCard from "./BetCard";
import BetTable from "./BetTable";

interface BetsDisplayProps {
  bets: Bet[];
  personas: any[];
  viewMode: "cards" | "table";
  isLoading: boolean;
  selectedPersonaId?: string;
  activeTab: string;
}

const BetsDisplay: React.FC<BetsDisplayProps> = ({
  bets,
  personas,
  viewMode,
  isLoading,
  selectedPersonaId,
  activeTab,
}) => {
  if (isLoading) {
    return (
      <div className="flex items-center justify-center p-8">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (bets.length === 0) {
    return (
      <div className="p-8 text-center flex flex-col items-center justify-center">
        <div className="text-4xl mb-2">🏆</div>
        <div className="text-muted-foreground">
          No {activeTab !== "all" ? activeTab : ""} bets found
        </div>
        <div className="text-xs text-zinc-500 mt-1">
          {selectedPersonaId
            ? "Try selecting a different agent or status"
            : "Bets will appear here once they are created"}
        </div>
      </div>
    );
  }

  return viewMode === "cards" ? (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3 p-3">
      {bets.map((bet) => (
        <BetCard
          key={bet.id}
          bet={bet}
          personaId={selectedPersonaId}
          personas={personas}
        />
      ))}
    </div>
  ) : (
    <BetTable
      bets={bets}
      personas={personas}
      selectedPersonaId={selectedPersonaId}
    />
  );
};

export default BetsDisplay;
